var Component = require("!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=script&index=0!./ArticleLoading.vue"),
  /* template */
  require("!!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c48da380\"}!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=template&index=0!./ArticleLoading.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ArticleLoading/ArticleLoading.vue
// module id = 191
// module chunks = 4